import LegalPage from "@/components/shared/LegalPage";

export default function CancellationBillingPolicyPage() {
  return (
    <LegalPage
      pageTestId="wc-cancellation-billing-policy"
      documentTitle="Cancellation & Billing Policy"
      title="Cancellation & Billing Policy"
      lastUpdated="July 2026"
      intro={[
        "We strive to provide transparent billing and exceptional service.",
        "By subscribing to WinCampaign, you agree to this policy.",
      ]}
      sections={[
        {
          heading: "Monthly Subscription",
          paragraphs: [
            "Subscriptions renew automatically each month.",
            "You may cancel your subscription at any time before your next billing date.",
            "Cancellation prevents future billing only.",
          ],
        },
        {
          heading: "5 Easy Payment Plan",
          paragraphs: [
            "The 5 Easy Payment Plan is a payment commitment. It includes the following terms:",
          ],
          bullets: [
            "Five-payment commitment required.",
            "Includes one (1) 30-day pause during the payment term.",
            "During the pause, your Done-for-You Business Growth Accelerator services will also be paused, including content creation, lead generation, and Discovery Call services.",
            "Monthly payments and services will automatically resume the following month until all five (5) installments have been completed.",
            "The 30-day pause is intended for temporary circumstances and may only be used once during the payment term.",
          ],
        },
        {
          paragraphs: [
            "The 5 Easy Payment Plan cannot be canceled before all five installments have been completed.",
          ],
        },
        {
          heading: "No Refunds",
          paragraphs: [
            "All payments are final.",
            "Due to the digital nature of our products, marketing services, content production, software access, and resource allocation:",
            "WinCampaign does not provide refunds, credits, or partial refunds for any payments already processed.",
          ],
        },
        {
          heading: "Service Delivery",
          paragraphs: [
            "Marketing services begin after onboarding requirements have been completed.",
            "Delivery timelines may vary based on:",
          ],
          bullets: [
            "Onboarding completion",
            "Submitted assets",
            "Communication delays",
            "Production schedules",
          ],
        },
        {
          heading: "Client Delays",
          paragraphs: [
            "Delays caused by missing client information, branding assets, approvals, or communication do not constitute grounds for refunds or credits.",
          ],
        },
        {
          heading: "Failed Payments",
          paragraphs: [
            "Accounts with failed payments may have services paused until payment is successfully processed.",
          ],
        },
        {
          heading: "Billing Changes",
          paragraphs: [
            "WinCampaign reserves the right to modify pricing with advance notice where required.",
            "Pricing changes do not affect completed billing periods.",
          ],
        },
        {
          heading: "Contact",
          paragraphs: ["support@wincampaign.io"],
        },
      ]}
    />
  );
}
